var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 2.08325H9.37498C4.16665 2.08325 2.08331 4.16659 2.08331 9.37492V15.6249C2.08331 20.8333 4.16665 22.9166 9.37498 22.9166H15.625C20.8333 22.9166 22.9166 20.8333 22.9166 15.6249V13.5416",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7083 3.14573L8.5 11.3541C8.1875 11.6666 7.875 12.2811 7.8125 12.7291L7.36458 15.8645C7.19791 16.9999 8 17.7916 9.13541 17.6353L12.2708 17.1874C12.7083 17.1249 13.3229 16.8124 13.6458 16.4999L21.8542 8.29156C23.2708 6.8749 23.9375 5.22906 21.8542 3.14573C19.7708 1.0624 18.125 1.72906 16.7083 3.14573Z",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 4.323C15.8767 5.54953 16.5312 6.66682 17.4322 7.56784C18.3333 8.46886 19.4506 9.12342 20.6771 9.46883",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ceacc408ed1a571838b3f9f4f3334a9d.svg";
export { ForwardRef as ReactComponent };